export const config = {
  imagePath: '/images/custom-software-development.webp',
  imagePathMobile: '/images/custom-software-development-mobile.webp',
  imageAlt: 'Custom software development',
  title: (
    <>
      <span>Modsen custom</span>
      <br />
      software Development
    </>
  ),
  subtitle:
    'Premium-quality software has the power to turn average businesses into major success stories. Build yours using top-tier custom software development services our team of senior-level professionals has to offer.',
  overlay: false,
}
